import { useSyncExternalStore } from 'react'

/* Whether the F-85 "complete your registration" modal is up. Other prompts
   (the profile photo bar) stay out of the way while it is. */
let open = false
const listeners = new Set<() => void>()

export const setCompleteProfileOpen = (value: boolean) => {
  if (open === value) return
  open = value
  listeners.forEach((listener) => listener())
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}

export const useCompleteProfileOpen = () => useSyncExternalStore(subscribe, () => open)
